import styled from "@emotion/styled";
import React from "react";

export default function Loading(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >
): JSX.Element {
  const LoadingContainer = styled.div`
    margin: 0 auto;
    padding: 20px;
  `;

  const StyledLoading = styled.div`
    border: 7px solid #f3f3f3;
    border-top: 7px solid #fb972e;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `;

  return (
    <LoadingContainer>
      <StyledLoading {...props} />
    </LoadingContainer>
  );
}
